import React from "react";
import { AgGridReact } from "ag-grid-react";
import { useMemo, useState, useCallback, useRef, useEffect } from "react";

import * as Icon from "react-bootstrap-icons";
 
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Multiselect from 'multiselect-react-dropdown';
import Select from "react-select";
import _ from 'lodash';
import CheckboxTree from "react-checkbox-tree-enhanced";
import { ThreeCircles } from "react-loader-spinner";
import './SuperAdmin.css'
import { ToastContainer, toast } from "react-toastify";
import { getValuesAsList, getKeyByValue, OptionRenderer } from "../../utils"

/**
 * A grid cell renderer button.
 * @param {*} props: props include the selected row data for editing.
 * @returns A button for editing the row in grid.
 */
const BtnCellRenderer = (props) => {
    const editClick = () => {
        props.setModal(true);
        props.selectedRow(props.data);
    }

    return (<Button className="grid-button" onClick={() => editClick()}><Icon.PencilSquare /></Button>);
}

/**
 * A grid cell renderer button.
 * @param {*} props: props include the selected firm data for activating / deactivating.
 * @returns Toggle button to activate or deactivate firm. 
 */
const DeactivateFirmRenderer = (props) => {
    let token = localStorage.getItem("token");
    const [activeToggle, setActiveToggle] = useState(props.data.Active);
    const handleDeactivate = (props) => {
        setActiveToggle(!activeToggle)
        // console.log("EDIT FIRM PLANS: ", props)
        const payload = {
            "FirmId": props.data["Firm Id"],
            "Active": !activeToggle ? "Y" : "N"
        }
        console.log("PAYLOAD: ", payload)
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(payload),
        };
        fetch(
            `${process.env.REACT_APP_BASE_URI}/workflow/subscriptions/packages/firms/active_status/`,
            requestOptions
        ).then((result) => result.json())
            .then((data) => {
                console.log("data successfully saved", data);
                if (data.success == true) {
                    toast.success(
                        "Data successfully saved!",
                        {
                            toastId: "Success1",
                            position: "bottom-right",
                            autoClose: 2500,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            className: "toastify-color-success",
                        }
                    );
                } else {
                    toast.error(
                        "Saving failed, please contact support.",
                        {
                            toastId: "Failure1",
                            position: "bottom-right",
                            autoClose: 2500,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            className: "toastify-color-error",
                        }
                    );
                }
            })
            .catch((err) => console.log("Err: ", err));
    }
    const Switch = ({ isToggled, onClick }) => {
        return (
            <label className="switch">
                <input type="checkbox" checked={isToggled} onChange={onClick} />
                <span className="super-admin-slider super-admin-round"></span>
            </label>
        );
    };

    return (
        <Switch
            isToggled={activeToggle}
            onClick={() => handleDeactivate(props)}
        ></Switch>
    );
}

function MyVerticallyCenteredModalEditPlans(props) {
    // console.log("MODAL EDIR PROPS: ", props)
    let token = localStorage.getItem("token");
    const [selectedPlan, setSelectedPlan] = useState(OptionRenderer([props.selectedrowdata.Plans]));
    const [apiInProgress, setApiInProgress] = useState(false);
    const editFirmPlans = (props) => {
        // console.log("EDIT FIRM PLANS: ", props)
        setApiInProgress(true)
        const payload = {
            "data": [
                {
                    "FirmId": props.selectedrowdata["Firm Id"],
                    "PackageId": parseInt(getKeyByValue(props.allplans, selectedPlan.value))
                }
            ]
        };
        // console.log("PAYLOAD: ", payload)
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(payload),
        };
        fetch(
            `${process.env.REACT_APP_BASE_URI}/workflow/subscriptions/packages/firms/`,
            requestOptions
        ).then((result) => result.json())
            .then((data) => {
                console.log("data successfully saved", data);
                if (data.success == true) {
                    toast.success(
                        "Data successfully saved!",
                        {
                            toastId: "Success2",
                            position: "bottom-right",
                            autoClose: 2500,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            className: "toastify-color-success",
                        }
                    );
                } else {
                    toast.error(
                        "Saving failed, please contact support.",
                        {
                            toastId: "Failure2",
                            position: "bottom-right",
                            autoClose: 2500,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            className: "toastify-color-error",
                        }
                    );
                }
                return data
            })
            .then(() => setApiInProgress(false))
            .catch((err) => console.log("Err: ", err));
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static"
            centered
            className="admin-modal"
            scrollable="false"
        >
            <Modal.Header closeButton>
                <h5>Manage plan for {props.selectedrowdata["Firm Name"]}</h5>
            </Modal.Header>
            <Modal.Body className="show-grid">
                <span className="select-label">Selected firm: <h5 style={{ fontSize: "var(--h7" }}>{props.selectedrowdata["Firm Name"]}</h5></span>
                <hr />
                <span className="select-label">Select your plan: </span>
                <Select
                    options={OptionRenderer(getValuesAsList(props.allplans))}
                    value={selectedPlan}
                    aria-label="Default"
                    closeMenuOnSelect={true}
                    autosize={true}
                    placeholder="Select your plan"
                    menuPosition="fixed"
                    defaultValue={selectedPlan}
                    onChange={setSelectedPlan}
                    // isLoading={isSelectOptionsLoading}
                    className='custom-select '
                    classNamePrefix="react-select"
                    isClearable
                />
            </Modal.Body>
            <Modal.Footer className="action-footer">
                <Button onClick={() => editFirmPlans(props)} className={!apiInProgress ? "superadmin-button" : "apiInProgress"}>{!apiInProgress ? "Update" :
                    <>Update &nbsp;
                        <ThreeCircles
                            height="20"
                            width="20"
                            color="#4fa94d"
                            wrapperStyle={{}}
                            wrapperClass=""
                            visible={true}
                            ariaLabel="three-circles-rotating"
                            outerCircleColor="var(--theme1_primary)"
                            innerCircleColor="var(--theme1_secondary)"
                            middleCircleColor="var(--theme1_tertiary)"
                        />
                    </>}</Button>
            </Modal.Footer>
        </Modal>
    );
}

function MyVerticallyCenteredModalEditFeatures(props) {
    let token = localStorage.getItem("token");
    const preSelectedValues = props.selectedrowdata["Features"];
    const [checked, setChecked] = useState(preSelectedValues);
    const [expanded, setExpanded] = useState([]);
    const treeNodes = props.treenodes;
    const [apiInProgress, setApiInProgress] = useState(false);
    const onCheck = (value) => { setChecked(value) };
    const onExpand = (value) => { setExpanded(value) };
    // console.log("TREENODES: ", treeNodes)
    // console.log("checked: ", checked)
    const editPlanFeatures = (props) => {
        setApiInProgress(true)
        const selectedFeatures = []
        const allFeatures = props.allfeatures
        for (let option in checked) {
            for (const feature in allFeatures) {
                if (allFeatures[feature].Name == checked[option]) {
                    selectedFeatures.push(allFeatures[feature].FeatureId)
                }
            }
        }
        const payload = {
            "PackageId": props.selectedrowdata["Plan Id"],
            "FeaturesList": selectedFeatures
        };
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(payload),
        };
        fetch(
            `${process.env.REACT_APP_BASE_URI}/workflow/subscriptions/packages/`,
            requestOptions
        ).then((result) => result.json())
            .then((data) => {
                console.log("data successfully saved", data);
                if (data.success == true) {
                    toast.success(
                        "Data successfully saved!",
                        {
                            position: "bottom-right",
                            autoClose: 2500,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            className: "toastify-color-success",
                        }
                    );
                } else {
                    toast.error(
                        "Saving failed, please contact support.",
                        {
                            position: "bottom-right",
                            autoClose: 2500,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            className: "toastify-color-error",
                        }
                    );
                }
            }).then(() => {
                setApiInProgress(false)
            })
            .catch((err) => console.log("Err: ", err));
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static"
            centered
            className="admin-modal"
            scrollable="false"
        >
            <Modal.Header closeButton>
                <h5>Manage features for {props.selectedrowdata["Plan"]}</h5>
            </Modal.Header>
            <Modal.Body className="show-grid  ">
                <span className="select-label">Selected plan: <h5 style={{ fontSize: "var(--h7" }}>{props.selectedrowdata["Plan"]}</h5></span>
                <hr />
                <br />
                <span className="select-label">Select features to enable or disable: </span>
                <CheckboxTree
                    checked={checked}
                    expanded={expanded}
                    nodes={treeNodes}
                    onCheck={onCheck}
                    onExpand={onExpand}
                />
            </Modal.Body>
            <Modal.Footer className="action-footer">
                <Button onClick={() => editPlanFeatures(props)} className={!apiInProgress ? "superadmin-button" : "apiInProgress"}>{!apiInProgress ? "Update" :
                    <>Update &nbsp;
                        <ThreeCircles
                            height="20"
                            width="20"
                            color="#4fa94d"
                            wrapperStyle={{}}
                            wrapperClass=""
                            visible={true}
                            ariaLabel="three-circles-rotating"
                            outerCircleColor="var(--theme1_primary)"
                            innerCircleColor="var(--theme1_secondary)"
                            middleCircleColor="var(--theme1_tertiary)"
                        />
                    </>}</Button>
            </Modal.Footer>
        </Modal>
    );
}

export const SuperAdminPlanGrid = (props) => {
    // console.log("SUPER ADMIN PLAN GRID PROPS: ", props)
    const gridRef = useRef();
    const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
    const onFirstDataRendered = useCallback(() => { gridRef.current.api.sizeColumnsToFit() }, []);
    const defaultColDef = useMemo(() => ({
            sortable: true,
            filter: true,
            resizable: true,
            animateRows: true,
        }), []);
    const [modalShow, setModalShow] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState({});
    const onSelectionChanged = () => { const selectedData = gridRef.current.api.getSelectedRows() };
    const [columnDefs, setColumnDefs] = useState([
        {
            field: "Actions", enablePivot: true,
            cellStyle: { 'border-right-color': '#ccc' },
            maxWidth: 100,
            cellRenderer: BtnCellRenderer,
            cellRendererParams: {
                setModal: setModalShow,
                selectedRow: setSelectedRowData
            }
        },
        { field: "Firm Name", enablePivot: true, resizable: true, suppressSizeToFit: true },
        { field: "Plans", enablePivot: true },
        {
            field: "Active", enablePivot: true,
            cellStyle: { 'border-right-color': '#ccc' },
            maxWidth: 100,
            cellRenderer: DeactivateFirmRenderer,
        },
    ]);
    const allPlans = props.allPlansData;

    return (
        <>
            {modalShow
                ?
                <MyVerticallyCenteredModalEditPlans
                    show={modalShow}
                    allplans={allPlans}
                    selectedrowdata={selectedRowData}
                    onHide={() => setModalShow(false)}
                />
                :
                <></>
            }
            <div className="ag-theme-balham" style={gridStyle}>
                <AgGridReact
                    ref={gridRef}
                    rowData={props.rowData}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    onGridReady={props.onGridReady}
                    alwaysShowHorizontalScroll={true}
                    alwaysShowVerticalScroll={true}
                    sideBar={"filters"}
                    onFirstDataRendered={onFirstDataRendered}
                    suppressRowClickSelection={true}
                    rowSelection={true}
                    onSelectionChanged={onSelectionChanged}
                />
            </div>
        </>
    );
};

export const SuperAdminFeatureGrid = (props) => {
    // console.log("SUPER ADMIN FEATURE GRID PROPS: ", props)
    const gridRef = useRef();
    const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
    const onFirstDataRendered = useCallback(() => { gridRef.current.api.sizeColumnsToFit() }, []);
    const defaultColDef = useMemo(() => ({
            sortable: true,
            filter: true,
            resizable: true,
            animateRows: true,
        }), []);
    const [modalShow, setModalShow] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState({});
    const onSelectionChanged = () => { const selectedData = gridRef.current.api.getSelectedRows() };
    const [columnDefs, setColumnDefs] = useState([
        {
            field: "Actions", enablePivot: true,
            cellStyle: { 'border-right-color': '#ccc' },
            maxWidth: 100,
            cellRenderer: BtnCellRenderer,
            cellRendererParams: {
                setModal: setModalShow,
                selectedRow: setSelectedRowData
            }
        },
        { field: "Plan", enablePivot: true, resizable: true, suppressSizeToFit: true },
        { field: "Features", enablePivot: true }
    ]);
    const allFeatures = props.allFeaturesData;

    return (
        <>
            {modalShow
                ?
                <MyVerticallyCenteredModalEditFeatures
                    show={modalShow}
                    allfeatures={allFeatures}
                    selectedrowdata={selectedRowData}
                    treenodes={props.checkTreeNodes}
                    onHide={() => setModalShow(false)}
                />
                :
                <></>
            }
            <div className="ag-theme-balham" style={gridStyle}>
                <AgGridReact
                    ref={gridRef}
                    rowData={props.rowData}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    onGridReady={props.onGridReady}
                    alwaysShowHorizontalScroll={true}
                    alwaysShowVerticalScroll={true}
                    sideBar={"filters"}
                    onFirstDataRendered={onFirstDataRendered}
                    suppressRowClickSelection={true}
                    rowSelection={true}
                    onSelectionChanged={onSelectionChanged}
                />
            </div>
        </>
    );
};